/** Stable DOM host for ERP dropdown portals — avoids insertBefore races with table re-renders. */
export function getQawaemPortalRoot() {
  if (typeof document === 'undefined') return null;
  let root = document.getElementById('qawaem-portal-root');
  if (!root) {
    root = document.createElement('div');
    root.id = 'qawaem-portal-root';
    root.setAttribute('data-qawaem-portal', 'true');
    document.body.appendChild(root);
  }
  return root;
}
